module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "license-item column is-one-quarter"
  }, [_c('div', {
    staticClass: "license-wrapper"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLicense(_vm.license.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "license-photo-wrapper"
  }, [(!_vm.license.photo) ? _c('div', {
    staticClass: "license-photo is-flex centered",
    on: {
      "click": _vm.handleLoadServicePhoto
    }
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "photo-container"
  }, [(_vm.license.photo || _vm.base64photo) ? _c('div', [(_vm.base64photo) ? _c('img', {
    attrs: {
      "src": _vm.base64photo
    }
  }) : _c('img', {
    attrs: {
      "src": "/upload/photos/" + _vm.license.photo
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.deletePhoto()
      }
    }
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    }
  }), _vm._v("\n            Удалить фото\n          ")])])]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "license-data"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Название лицензии",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.license.name),
      callback: function($$v) {
        _vm.$set(_vm.license, "name", $$v)
      },
      expression: "license.name"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Номер лицензии"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.license.number),
      callback: function($$v) {
        _vm.$set(_vm.license, "number", $$v)
      },
      expression: "license.number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveLicense()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "button-wrapper"
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Загрузить фото лицензии\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-976046aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/LicenseItem.vue
// module id = 986
// module chunks = 0